module.exports = __webpack_public_path__ + "img/logo-gagarin-wt.6b487de6.svg";